import { Tabs } from 'antd'
import React, { FunctionComponent } from 'react'

import { PROPERTY_TYPES } from '../../common/drmTypes'
import { InsolvencyMonitoringTab } from '../components/InsolvencyMonitoringTab/InsolvencyMonitoringTab'
import { PageLayout } from '../components/PageLayout/PageLayout'
import { PropertyDetailDrawer } from '../components/PropertyDetailDrawer/PropertyDetailDrawer'
import { PropertyMonitoringViewType } from '../components/PropertyMonitoringViewType/PropertyMonitoringViewType'
import { TabLabel } from '../components/TabLabel/TabLabel'
import { monitoringTabSlug, tabsProps } from '../utils/tabsHelpers'
import { useInitialFetchWatchdog } from '../utils/useFetchWatchdog'
import { useTabKeyState } from '../utils/useTabKeyState'

const labelClassName = 'text-base text-center block w-28'
const tabItems = [
  {
    key: PROPERTY_TYPES.BUILDING,
    label: <TabLabel title="Budovy" className={labelClassName} />,
    children: (
      <InsolvencyMonitoringTab propertyType={PROPERTY_TYPES.BUILDING} />
    ),
  },
  {
    key: PROPERTY_TYPES.AREA,
    label: <TabLabel title="Pozemky" className={labelClassName} />,
    children: <InsolvencyMonitoringTab propertyType={PROPERTY_TYPES.AREA} />,
  },
  {
    key: PROPERTY_TYPES.UNIT,
    label: <TabLabel title="Jednotky" className={labelClassName} />,
    children: <InsolvencyMonitoringTab propertyType={PROPERTY_TYPES.UNIT} />,
  },
]

export const InsolvencyMonitoring: FunctionComponent = () => {
  useInitialFetchWatchdog()
  const [activeTabKey, setActiveTabKey] = useTabKeyState<PROPERTY_TYPES>(
    PROPERTY_TYPES.BUILDING,
    monitoringTabSlug
  )

  return (
    <>
      <PageLayout title="Monitoring insolvencí - výpis nemovitostí" isContainer>
        <Tabs
          {...tabsProps}
          items={tabItems}
          activeKey={activeTabKey}
          onTabClick={setActiveTabKey}
          tabBarExtraContent={<PropertyMonitoringViewType withCompact />}
        />
      </PageLayout>
      <PropertyDetailDrawer />
    </>
  )
}

export default InsolvencyMonitoring
